import { BillingPlan } from "@/data/billing/BillingPlan";
import { Card, CardContent } from "@mui/material";
import { Component } from "react";
import { Utils } from "../common/Utils";
import { withLocale, WithLocaleProps } from "../providers/LocaleProvider";
import StarterIcon from "../resources/images/icons-building-1.svg";
import LargeIcon from "../resources/images/icons-building-2.svg";
import OrganizationIcon from "../resources/images/icons-building-3.svg";
import { Button } from "./Button";

interface BillingGroupCardProps extends WithLocaleProps {
  group?: BillingPlan;
  onClick?: (e: any, group?: BillingPlan) => void;
  selected?: boolean;
  existing?: boolean;
  disabled?: boolean;
}

class BillingGroupCardBase extends Component<BillingGroupCardProps> {
  constructor(props: BillingGroupCardProps) {
    super(props);
  }

  render() {
    const { group, onClick, selected, existing, disabled, translate } = this.props;

    return (
      <Card
        className={
          "klayo_billingplancard klayo_billingplancard-" +
          group?.name.toLowerCase() +
          (selected ? " klayo_billingplancard--selected" : "") +
          (disabled ? " klayo_billingplancard--disabled" : "")
        }
        onClick={
          onClick && !disabled && !group?.isCustom ? (e: any) => onClick(e, group) : undefined
        }
      >
        <CardContent>
          <div className='klayo_billingplancard_contents'>
            <div className='klayo_billingplancard_icon'>
              {group?.employeeCap <= 25 ? (
                <StarterIcon />
              ) : group?.employeeCap <= 50 ? (
                <LargeIcon />
              ) : (
                <OrganizationIcon />
              )}
            </div>
            <div className='klayo_billingplancard_details'>
              <div className='klayo_billingplancard_name'>
                {(group?.isCustom ? translate("billing.enterprise") : group?.name) +
                  (existing ? ` (${translate("billing.yourCurrentPlan")})` : "")}
              </div>
              <div className='klayo_billingplancard_users'>
                {(group?.employeeCapDescription ||
                  (group?.isCustom
                    ? translate("billing.overXUsers", { count: 200 })
                    : translate("billing.upToXUsers", { count: group?.employeeCap }))) +
                  (!group?.isAllowed ? ` (${translate("billing.overLimitForPlan")})` : "")}
              </div>
            </div>
            {group?.isCustom && (
              <div>
                <Button
                  label={translate("billing.contactUs")}
                  size='md'
                  onClick={(e) => onClick?.(e, group)}
                />
              </div>
            )}
            {!group?.isCustom && (
              <div className='klayo_billingplancard_price'>
                <div className='klayo_billingplancard_pricepercycle'>
                  {group?.pricePerMonthDescription ||
                    "$" +
                      Utils.formatCurrency(group?.pricePerCycle) +
                      " / " +
                      group?.cycle.perLabel}
                </div>
                <div className='klayo_billingplancard_priceperuser'>
                  {group?.pricePerEmployeeDescription ||
                    "$" +
                      Utils.formatCurrency(group?.pricePerUser) +
                      " / " +
                      translate("billing.user")}
                </div>
              </div>
            )}
          </div>
        </CardContent>
      </Card>
    );
  }
}

export const BillingGroupCard = withLocale(BillingGroupCardBase);
